module.exports = __webpack_public_path__ + "img/4.9106e8f9.png";